import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore"; // getDoc 사용!
import styles from "./CeoMessage.module.css";

const VideoClip = () => {
  const { id: companyId } = useParams(); // URL에서 `companyId` 가져오기
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!companyId) {
      setError("Company ID is missing in URL.");
      setLoading(false);
      return;
    }

    // Firestore에서 특정 회사의 `videos.videoClip` 필드를 가져오기
    const fetchVideos = async () => {
      try {
        const companyRef = doc(db, "companies", companyId);
        const companySnap = await getDoc(companyRef);

        if (companySnap.exists()) {
          const companyData = companySnap.data();
          console.log("📄 Firestore에서 불러온 회사 데이터:", companyData);

          if (companyData.videos && companyData.videos.videoClip) {
            const videoClip = Array.isArray(companyData.videos.videoClip)
              ? companyData.videos.videoClip
              : [companyData.videos.videoClip];

            setVideos(videoClip.map((video) => ({ videoUrl: video })));
          } else {
            setError("No videoClip found.");
          }
        } else {
          setError("Company not found.");
        }
      } catch (error) {
        console.error("🔥 videoClip 불러오기 실패:", error);
        setError("Failed to load CEO messages.");
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, [companyId]);

  if (loading) {
    return <h2 className={styles.loading}>Loading...</h2>;
  }

  if (error) {
    return <h2 className={styles.notFound}>{error}</h2>;
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Video Clip</h2>

      {/* CEO Message 등록된 영상 리스트 */}
      <div className={styles.videoGrid}>
        {videos.length > 0 ? (
          videos.map((video, index) => (
            <div key={index} className={styles.videoCard}>
              <iframe
                width="100%"
                height="200"
                src={video.videoUrl}
                title={`Video Clip ${index + 1}`}
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          ))
        ) : (
          <p>📭 등록된 Video Clip이 없습니다.</p>
        )}
      </div>
    </div>
  );
};

export default VideoClip;
